import React from 'react'
import { UIBadge, type UIBadgeProps } from './ui-badge'

export interface UIBadgeRoundedProps extends Omit<UIBadgeProps, 'shape' | 'children'> {
  children?: React.ReactNode
}

/**
 * UIBadgeRounded - Rounded Badge Block
 * 완전히 둥근 모양의 배지 컴포넌트입니다.
 * 완전히 둥근 모양의 배지입니다.
 */
export const UIBadgeRounded = React.forwardRef<HTMLSpanElement, UIBadgeRoundedProps>(
  ({ children = "Rounded", ...props }, ref) => {
    return (
      <UIBadge
        ref={ref}
        shape="pill"
        {...props}
      >
        {children}
      </UIBadge>
    )
  }
)

UIBadgeRounded.displayName = "UIBadgeRounded"